import { Injectable } from '@angular/core';

import { ConfigurationService } from 'src/core/index/services.index';
import { MenuItem } from 'src/core/index';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationServiceCustom extends ConfigurationService {

  override getDashboardMenuItems(): MenuItem[] {
    return [
      this.appSections.dashboard,
      this.appSections.myCourses,
      this.appSections.search,
      this.appSections.calendar,
    ];
  }

  override getUserMenuItems(): MenuItem[] {
    return super.getUserMenuItems().filter(item => item.id !== 'help');
  }
}